import React from 'react';

import { Icon } from '../icons';

export const OpenQuestionIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 14 14" stroke={color} style={style}>
      <g xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none">
        <path
          d="M6.39844 4.8125H2.1875V9.625H6.19792M10.0078 4.8125H11.8125V9.625H10.0078"
          strokeWidth="0.65625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8.3125 3.0625V10.9375" strokeWidth="0.65625" strokeLinecap="round" />
        <path d="M9.1875 3.0625H7.4375" strokeWidth="0.65625" strokeLinecap="round" />
        <path d="M9.1875 10.9375H7.4375" strokeWidth="0.65625" strokeLinecap="round" />
      </g>
    </svg>
  );
};
